import { ClientPayloadProps } from "modules/video/video_detail/store/actionType";

export enum actionTypes {
  FETCH_FEATURED_ADS_REQUEST = "FETCH_FEATURED_ADS_REQUEST",
  FETCH_FEATURED_ADS_SUCCESS = "FETCH_FEATURED_ADS_SUCCESS",
  FETCH_FEATURED_ADS_FAIL = "FETCH_FEATURED_ADS_FAIL",

  CREATE_FEATURED_ADS_REQUEST = "CREATE_FEATURED_ADS_REQUEST",
  CREATE_FEATURED_ADS_SUCCESS = "CREATE_FEATURED_ADS_SUCCESS",
  CREATE_FEATURED_ADS_FAIL = "CREATE_FEATURED_ADS_FAIL",

  UPDATE_FEATURED_ADS_REQUEST = "UPDATE_FEATURED_ADS_REQUEST",
  UPDATE_FEATURED_ADS_SUCCESS = "UPDATE_FEATURED_ADS_SUCCESS",
  UPDATE_FEATURED_ADS_FAIL = "UPDATE_FEATURED_ADS_FAIL",

  UPLOAD_FEATURED_ADS_VIDEO_REQUEST = "UPLOAD_FEATURED_ADS_VIDEO_REQUEST",
  UPLOAD_FEATURED_ADS_VIDEO_SUCCESS = "UPLOAD_FEATURED_ADS_VIDEO_SUCCESS",
  UPLOAD_FEATURED_ADS_VIDEO_FAIL = "UPLOAD_FEATURED_ADS_VIDEO_FAIL",

  DELETE_FEATURED_ADS_REQUEST = "DELETE_FEATURED_ADS_REQUEST",
  DELETE_FEATURED_ADS_SUCCESS = "DELETE_FEATURED_ADS_SUCCESS",
  DELETE_FEATURED_ADS_FAIL = "DELETE_FEATURED_ADS_FAIL",

  RESET_FEATURED_ADS = "RESET_FEATURED_ADS",
}
export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export const FeaturedVideoFolderId = "02c7b007a70e45cfb31bc6e4d42411ca"
export interface FeaturedAdsProps {
  created_at: string;
  featured_type: string;
  featured_order: number;
  id: string;
  image: string;
  name: string;
  status: string;
  updated_at: string;
  video: string;
  playback_info: string;
  otp: string;
  identifier:string;
  upload_status:string;
}
export interface FeaturedAdsFetchProps {
  featuredAds: FeaturedAdsProps[];
  clientPayload: ClientPayloadProps;
}
export interface FeaturedAdsCreateProps {
  featuredAd: FeaturedAdsProps;
  clientPayload: ClientPayloadProps;
}

export interface FeaturedAdsInput {
  name: string;
  status: string;
  featured_type: string;
  featured_order: number;
  image?: string;
  video?: string;
}
export interface FeaturedAdsInputError {
  name?: string;
  status?: string;
  imageFile?: string;
  video?:string;
  featured_type?: string;
  featured_order?: string;
}
export interface UploadFeaturedAdsVideoInput {
  title: string;
  folder_id: string;
  create_video_id: string;
}

//FetchFeaturedAds
export interface FetchFeaturedAdsRequestAction {
  type: actionTypes.FETCH_FEATURED_ADS_REQUEST;
}

export interface FetchFeaturedAdsSuccessAction {
  type: actionTypes.FETCH_FEATURED_ADS_SUCCESS;
  payload: FeaturedAdsProps[];
}

export interface FetchFeaturedAdsFailureAction {
  type: actionTypes.FETCH_FEATURED_ADS_FAIL;
  payload: string;
}
//CreateFeaturedAds
export interface CreateFeaturedAdsRequestAction {
  type: actionTypes.CREATE_FEATURED_ADS_REQUEST;
}

export interface CreateFeaturedAdsSuccessAction {
  type: actionTypes.CREATE_FEATURED_ADS_SUCCESS;
  payload: FeaturedAdsProps;
}

export interface CreateFeaturedAdsFailureAction {
  type: actionTypes.CREATE_FEATURED_ADS_FAIL;
  payload: string;
}
//UpdateFeaturedAds
export interface UpdateFeaturedAdsRequestAction {
  type: actionTypes.UPDATE_FEATURED_ADS_REQUEST;
}

export interface UpdateFeaturedAdsSuccessAction {
  type: actionTypes.UPDATE_FEATURED_ADS_SUCCESS;
  payload: FeaturedAdsProps;
}

export interface UpdateFeaturedAdsFailureAction {
  type: actionTypes.UPDATE_FEATURED_ADS_FAIL;
  payload: string;
}
//UploadFeaturedAdsVideo
export interface UploadFeaturedAdsVideoRequestAction {
  type: actionTypes.UPLOAD_FEATURED_ADS_VIDEO_REQUEST;
}

export interface UploadFeaturedAdsVideoSuccessAction {
  type: actionTypes.UPLOAD_FEATURED_ADS_VIDEO_SUCCESS;
  payload: ClientPayloadProps;
}

export interface UploadFeaturedAdsVideoFailureAction {
  type: actionTypes.UPLOAD_FEATURED_ADS_VIDEO_FAIL;
  payload: string;
}
//DeleteFeaturedAds
export interface DeleteFeaturedAdsRequestAction {
  type: actionTypes.DELETE_FEATURED_ADS_REQUEST;
}

export interface DeleteFeaturedAdsSuccessAction {
  type: actionTypes.DELETE_FEATURED_ADS_SUCCESS;
  payload: string;
}

export interface DeleteFeaturedAdsFailureAction {
  type: actionTypes.DELETE_FEATURED_ADS_FAIL;
  payload: string;
}
export interface ResetFeaturedAdsAction {
  type: actionTypes.RESET_FEATURED_ADS;
}

export type FeaturedAdsActions =
  | FetchFeaturedAdsRequestAction
  | FetchFeaturedAdsSuccessAction
  | FetchFeaturedAdsFailureAction
  | CreateFeaturedAdsRequestAction
  | CreateFeaturedAdsSuccessAction
  | CreateFeaturedAdsFailureAction
  | UpdateFeaturedAdsRequestAction
  | UpdateFeaturedAdsSuccessAction
  | UpdateFeaturedAdsFailureAction
  | UploadFeaturedAdsVideoRequestAction
  | UploadFeaturedAdsVideoSuccessAction
  | UploadFeaturedAdsVideoFailureAction
  | DeleteFeaturedAdsRequestAction
  | DeleteFeaturedAdsSuccessAction
  | DeleteFeaturedAdsFailureAction
  | ResetFeaturedAdsAction;
